import { render, staticRenderFns } from "./exploracionFisicaShow.vue?vue&type=template&id=035d0085"
import script from "./exploracionFisicaShow.vue?vue&type=script&lang=js"
export * from "./exploracionFisicaShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports